import Header from './Header';
import Footer from './Footer';

export default function CountryPageSkeleton() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 animate-pulse">

        <section className="bg-surface border-b border-border">
          <div className="mx-auto max-w-5xl px-5 py-12 md:py-16">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-[30px] w-[40px] rounded-sm bg-gray-200" />
              <div className="h-4 w-20 rounded bg-gray-200" />
            </div>
            <div className="h-9 w-2/3 rounded-lg bg-gray-200 mb-3" />
            <div className="h-4 w-full max-w-2xl rounded bg-gray-200 mb-1" />
            <div className="h-4 w-4/5 max-w-2xl rounded bg-gray-200" />
          </div>
        </section>

        <section className="bg-bg">
          <div className="mx-auto max-w-5xl px-5 py-10 md:py-14">
            <div className="h-6 w-48 rounded bg-gray-200 mb-3" />
            <div className="h-4 w-80 rounded bg-gray-200 mb-[25px]" />
            <div className="overflow-hidden rounded-xl border border-border bg-surface">
              <table className="w-full text-left text-[14px]">
                <thead>
                  <tr className="border-b border-border bg-bg">
                    {[1, 2, 3].map(i => (
                      <th key={i} className="px-5 py-3.5">
                        <div className="h-4 w-16 rounded bg-gray-200" />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4].map((row, i, arr) => (
                    <tr key={row} className={i < arr.length - 1 ? 'border-b border-border' : ''}>
                      <td className="px-5 py-4">
                        <div className="h-4 w-24 rounded bg-gray-200" />
                      </td>
                      <td className="px-5 py-4">
                        <div className="h-4 w-16 rounded bg-gray-200" />
                      </td>
                      <td className="px-5 py-4 text-right">
                        <div className="ml-auto h-8 w-20 rounded-md bg-gray-200" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section className="bg-surface border-t border-border">
          <div className="mx-auto max-w-5xl px-5 py-10 md:py-14">
            <div className="h-6 w-40 rounded bg-gray-200 mb-4" />
            <ul className="space-y-3">
              {[1, 2, 3].map(n => (
                <li key={n} className="flex items-start gap-3">
                  <div className="mt-0.5 h-5 w-5 shrink-0 rounded-full bg-gray-200" />
                  <div className="h-4 flex-1 rounded bg-gray-200" />
                </li>
              ))}
            </ul>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
}
